module.exports = __webpack_public_path__ + "static/logo-no-text-fa5ab06175d2dcd4c60e6897997b8ccd.png";